// // GatewayBanner.jsx
// import React from 'react';
// import { 
//   ArrowRight, 
//   Building2, 
//   Factory, 
//   Microscope, 
//   Users, 
//   Rocket,
//   CheckCircle,
//   Globe,
//   Zap,
//   Shield,
//   Sparkles
// } from 'lucide-react';
// import './Facilitieshomepage.css';
// import Navbar from './Navbar';
// import FacilityInfo from './FacilityInfo';
// import  CTA from './CTA';
// import Footer from'./Footer';
// import Facilities from '../../pages/Facilities.jsx';

// const GatewayBanner = () => {
//   const stats = [
//     { value: "50+", label: "Facilities" },
//     { value: "2,500+", label: "Innovators" },
//     { value: "150+", label: "Machines" },
//     { value: "12", label: "Centres" }
//   ];

//   return (
//     <>
//     <Navbar/>
//     <section className="gateway-banner">
//       {/* Background Image with Overlay */}
//       <div className="gateway-background">
//         <img
//           src="https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=1600&q=80"
//           alt="Modern manufacturing facility"
//           className="gateway-bg-image"
//           loading="eager"
//         />
//         <div className="gateway-overlay"></div>
//         <div className="gateway-glow-1"></div>
//         <div className="gateway-glow-2"></div>
//       </div>

//       {/* Content */}
//       <div className="gateway-content">
//         <div className="gateway-container">
//           {/* Left Side - Text Content */}
//           <div className="gateway-left">
//             {/* Badge */}
//             <div className="gateway-badge">
//               <Sparkles size={14} className="gateway-badge-icon" />
//               <span>Innovation Gateway</span>
//             </div>

//             {/* Heading */}
//             <h1 className="gateway-heading">
//               <span className="gateway-heading-line1">Turn your facility into</span>
//               <span className="gateway-heading-line2">a gateway for innovation.</span>
//             </h1>

//             {/* Description */}
//             <p className="gateway-description">
//               APIC ProtoHub connects manufacturing facilities, innovation centres, 
//               R&D labs, universities and technology providers with innovators, 
//               startups, and industry experts.
//             </p>

//             {/* Features Grid */}
//             <div className="gateway-features-grid">
//               <div className="gateway-feature-card">
//                 <div className="gateway-feature-icon">
//                   <Factory size={18} />
//                 </div>
//                 <div>
//                   <p className="gateway-feature-title">Manufacturing</p>
//                   <p className="gateway-feature-desc">Facilities & Production</p>
//                 </div>
//               </div>

//               <div className="gateway-feature-card">
//                 <div className="gateway-feature-icon">
//                   <Microscope size={18} />
//                 </div>
//                 <div>
//                   <p className="gateway-feature-title">R&D Labs</p>
//                   <p className="gateway-feature-desc">Research & Development</p>
//                 </div>
//               </div>

//               <div className="gateway-feature-card">
//                 <div className="gateway-feature-icon">
//                   <Building2 size={18} />
//                 </div>
//                 <div>
//                   <p className="gateway-feature-title">Innovation Centres</p>
//                   <p className="gateway-feature-desc">Hubs & Ecosystems</p>
//                 </div>
//               </div>

//               <div className="gateway-feature-card">
//                 <div className="gateway-feature-icon">
//                   <Users size={18} />
//                 </div>
//                 <div>
//                   <p className="gateway-feature-title">Universities</p>
//                   <p className="gateway-feature-desc">Academia & Research</p>
//                 </div>
//               </div>
//             </div>

//             {/* CTA */}
//             <button className="gateway-cta-btn">
//               <Rocket size={18} />
//               <span>Start Your Innovation Journey</span>
//               <ArrowRight size={18} className="gateway-cta-arrow" />
//             </button>

//             {/* Stats */}
//             {/* <div className="gateway-stats">
//               {stats.map((stat, index) => (
//                 <React.Fragment key={index}>
//                   <div className="gateway-stat-item">
//                     <p className="gateway-stat-value">{stat.value}</p>
//                     <p className="gateway-stat-label">{stat.label}</p>
//                   </div>
//                   {index < stats.length - 1 && (
//                     <div className="gateway-stat-divider"></div>
//                   )}
//                 </React.Fragment>
//               ))}
//             </div> */}
//           </div>

//           {/* Right Side - Image Card */}
//           <div className="gateway-right">
//             <div className="gateway-image-card">
//               <div className="gateway-image-wrapper">
//                 <img
//                   src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
//                   alt="Innovation facility with advanced machinery"
//                   className="gateway-right-image"
//                   loading="lazy"
//                 />
                
//                 {/* Floating Cards */}
//                 <div className="gateway-float-card card-1">
//                   <div className="gateway-float-icon">
//                     <Zap size={16} />
//                   </div>
//                   <div>
//                     <p className="gateway-float-title">Real-time</p>
//                     <p className="gateway-float-desc">Monitoring</p>
//                   </div>
//                 </div>

//                 <div className="gateway-float-card card-2">
//                   <div className="gateway-float-icon">
//                     <Shield size={16} />
//                   </div>
//                   <div>
//                     <p className="gateway-float-title">Secure</p>
//                     <p className="gateway-float-desc">Platform</p>
//                   </div>
//                 </div>

//                 <div className="gateway-float-card card-3">
//                   <div className="gateway-float-icon">
//                     <Globe size={16} />
//                   </div>
//                   <div>
//                     <p className="gateway-float-title">Global</p>
//                     <p className="gateway-float-desc">Network</p>
//                   </div>
//                 </div>

//                 {/* Trust Badge */}
//                 <div className="gateway-trust-badge">
//                   <div className="gateway-trust-avatars">
//                     <div className="gt-avatar">A</div>
//                     <div className="gt-avatar">B</div>
//                     <div className="gt-avatar">C</div>
//                     <div className="gt-avatar">D</div>
//                     <div className="gt-avatar-more">+2k</div>
//                   </div>
//                   <div>
//                     <p className="gateway-trust-text">Join 2,000+ innovators</p>
//                     <p className="gateway-trust-sub">Building the future</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//     <FacilityInfo/>
//     <Facilities/>
//       <CTA />
//      <Footer />
//     </>
//   );
// };

// export default GatewayBanner;




import React from "react";
import Navbar from "./Navbar";
import FacilityInfo from "./FacilityInfo";
import Facilitybuilt from "./Facilitybuilt";
import Facltywhyshould from "./Facltywhyshould";
import Facltyproject from './Facltyproject';
import Facltyqutection from './Facltyqutection'
import Facltyidea from './Facltyidea';
import Facltymantance from './Facltymantance';
import Facltytrasprent from './Facltytrasprent';
import Facltymanufachtureing from './Facltymanufachtureing';
import Facltyplatfrommange from './Facltyplatfrommange'
import Facltyonbording from './Facltyonbording';
import Footer from './Footer'

export default function ApicProtoHubHero() {
  return (
    <>
      <ResponsiveStyles />
      <Navbar />

      <div className="hero-stage" style={styles.stage}>
        <div className="hero-grid-overlay" style={styles.gridOverlay} />
        <div className="hero-wrap" style={styles.wrap}>
          {/* LEFT COLUMN */}
          <div className="hero-left">
            <span className="hero-eyebrow" style={styles.eyebrow}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 2L14 9L21 11L14 13L12 20L10 13L3 11L10 9L12 2Z"
                  fill="#f7941d"
                />
              </svg>
              BUILD &bull; CONNECT &bull; GROW
            </span>

            <h1 className="hero-heading" style={styles.heading}>
              Turn your facility
              <br />
              into a <span style={styles.accent}>gateway for</span>
              <br />
              <span style={styles.accent}>innovation.</span>
            </h1>

            <p className="hero-lede" style={styles.lede}>
              APIC ProtoHub connects manufacturing facilities, innovation
              centres, R&amp;D labs, universities and technology providers
              with innovators, startups, industries and government
              organisations turning ideas into real products. List your
              facility, showcase machines, receive RFQs, submit quotations
              and manage projects — all in one platform.
            </p>

            <div className="hero-cta-row" style={styles.ctaRow}>
              <a
                href="#"
                className="hero-btn hero-btn-primary"
                style={{ ...styles.btn, ...styles.btnPrimary }}
              >
                Register Your Facility
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </a>
              <a
                href="#"
                className="hero-btn hero-btn-secondary"
                style={{ ...styles.btn, ...styles.btnSecondary }}
              >
                Explore Listed Facilities
              </a>
              <a href="#" className="hero-link-ghost" style={styles.linkGhost}>
                Facility Login
              </a>
            </div>
          </div>

          {/* RIGHT COLUMN */}
          <div className="hero-visual-col" style={styles.visualCol}>
            <div className="hero-factory-card" style={styles.factoryCard}>
              <FactoryScene />

              <div className="hero-stat-chip" style={styles.statChip}>
                <div className="hero-stat-icon" style={styles.statIcon}>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#1a1204"
                    strokeWidth="2.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 8v4l3 2" />
                    <circle cx="12" cy="12" r="9" />
                  </svg>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div className="hero-stat-title" style={styles.statTitle}>
                    Machine Utilisation
                  </div>
                  <div className="hero-stat-sub" style={styles.statSub}>
                    Live capacity across 600+ machines
                  </div>
                </div>
                <div className="hero-stat-value" style={styles.statValue}>
                  78%
                </div>
              </div>
            </div>

            <div className="hero-rfq-card" style={styles.rfqCard}>
              <span className="hero-rfq-tag" style={styles.rfqTag}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="#8a7100">
                  <path d="M13 2L4 14h6l-1 8 9-12h-6l1-8z" />
                </svg>
                New RFQ
              </span>
              <div className="hero-rfq-title" style={styles.rfqTitle}>
                Prototype XYZ — Aerospace
              </div>
              <div className="hero-rfq-meta" style={styles.rfqMeta}>
                5-axis CNC &middot; Aluminium &middot; Qty 12
              </div>
            </div>
          </div>
        </div>
      </div>

      <FacilityInfo />
      <Facilitybuilt />
      <Facltywhyshould />
      <Facltyproject/>
      <Facltyqutection/>
      <Facltyidea/>
      <Facltymantance/>
      <Facltytrasprent/>
      <Facltymanufachtureing/>
      <Facltyplatfrommange/>
      <Facltyonbording/>
      <Footer/>
    </>
  );
}

function FactoryScene() {
  return (
    <div className="hero-factory-scene" style={styles.factoryScene}>
      <svg
        viewBox="0 0 600 380"
        preserveAspectRatio="xMidYMid slice"
        width="100%"
        height="100%"
      >
        <defs>
          <linearGradient id="floor" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#1b274a" />
            <stop offset="1" stopColor="#0a1226" />
          </linearGradient>
          <linearGradient id="beam" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#3a4b82" />
            <stop offset="1" stopColor="#212c50" />
          </linearGradient>
        </defs>
        <rect width="600" height="380" fill="url(#floor)" />
        <g stroke="#2c3766" strokeWidth="3">
          <line x1="0" y1="40" x2="600" y2="40" />
          <line x1="0" y1="70" x2="600" y2="70" />
        </g>
        <g stroke="#232f57" strokeWidth="2">
          <line x1="0" y1="300" x2="240" y2="380" />
          <line x1="600" y1="300" x2="360" y2="380" />
          <line x1="120" y1="280" x2="180" y2="380" />
          <line x1="480" y1="280" x2="420" y2="380" />
        </g>
        <g fill="#9fd8ff" opacity="0.85">
          <rect x="70" y="46" width="90" height="6" rx="3" />
          <rect x="250" y="46" width="90" height="6" rx="3" />
          <rect x="430" y="46" width="90" height="6" rx="3" />
        </g>
        <g fill="#9fd8ff" opacity="0.25">
          <ellipse cx="115" cy="90" rx="80" ry="40" />
          <ellipse cx="295" cy="90" rx="80" ry="40" />
          <ellipse cx="475" cy="90" rx="80" ry="40" />
        </g>
        <g>
          <rect
            x="30"
            y="150"
            width="110"
            height="150"
            rx="6"
            fill="url(#beam)"
            stroke="#3a4b82"
            strokeWidth="2"
          />
          <rect x="45" y="170" width="80" height="45" rx="4" fill="#141c39" />
          <rect
            x="460"
            y="150"
            width="110"
            height="150"
            rx="6"
            fill="url(#beam)"
            stroke="#3a4b82"
            strokeWidth="2"
          />
          <rect x="475" y="170" width="80" height="45" rx="4" fill="#141c39" />
        </g>
        <g stroke="#f7941d" strokeWidth="7" strokeLinecap="round" fill="none">
          <path d="M520 120 L520 160 L560 190 L545 230" />
        </g>
        <circle cx="520" cy="120" r="8" fill="#f7941d" />
        <circle cx="545" cy="230" r="7" fill="#f7941d" />
        <g fill="#0d1730" stroke="#2c3766" strokeWidth="1.5">
          <g transform="translate(230,240)">
            <circle cx="0" cy="0" r="12" />
            <rect x="-14" y="10" width="28" height="60" rx="8" />
            <rect x="-12" y="68" width="10" height="42" rx="4" />
            <rect x="2" y="68" width="10" height="42" rx="4" />
          </g>
          <g transform="translate(300,250)">
            <circle cx="0" cy="0" r="12" />
            <rect x="-14" y="10" width="28" height="60" rx="8" />
            <rect x="-12" y="68" width="10" height="42" rx="4" />
            <rect x="2" y="68" width="10" height="42" rx="4" />
          </g>
          <g transform="translate(365,245)">
            <circle cx="0" cy="0" r="12" />
            <rect x="-14" y="10" width="28" height="60" rx="8" />
            <rect x="-12" y="68" width="10" height="42" rx="4" />
            <rect x="2" y="68" width="10" height="42" rx="4" />
          </g>
        </g>
        <rect x="0" y="330" width="600" height="50" fill="#0a1226" opacity="0.7" />
      </svg>
    </div>
  );
}

/**
 * Global responsive rules.
 * Inline styles can't hold media queries, so breakpoint overrides for
 * layout (grid columns, spacing, font sizes, stacking order, absolute
 * card positions) live here and take priority via !important where needed.
 */
function ResponsiveStyles() {
  return (
    <style>{`
      /* ---------- Tablet / small laptop ---------- */
      @media (max-width: 1024px) {
        .hero-wrap {
          grid-template-columns: 1fr !important;
          gap: 56px !important;
          padding: 0 28px !important;
        }
        .hero-visual-col {
          order: 2;
        }
        .hero-left {
          order: 1;
        }
        .hero-heading {
          font-size: clamp(2rem, 5vw, 3rem) !important;
        }
        .hero-rfq-card {
          left: 16px !important;
          bottom: -40px !important;
          width: 280px !important;
        }
      }

      /* ---------- Mobile ---------- */
      @media (max-width: 640px) {
        .hero-stage {
          padding: 40px 0 96px !important;
          min-height: auto !important;
        }
        .hero-wrap {
          padding: 0 18px !important;
          gap: 40px !important;
        }
        .hero-eyebrow {
          font-size: 10.5px !important;
          padding: 7px 14px !important;
          letter-spacing: 0.1em !important;
        }
        .hero-heading {
          font-size: clamp(1.7rem, 8vw, 2.4rem) !important;
          margin-top: 20px !important;
          line-height: 1.15 !important;
        }
        .hero-lede {
          font-size: 0.96rem !important;
          margin-top: 18px !important;
          max-width: 100% !important;
        }
        .hero-cta-row {
          margin-top: 28px !important;
          gap: 14px !important;
          flex-direction: column !important;
          align-items: flex-start !important;
          width: 100%;
        }
        .hero-btn {
          width: 100% !important;
          justify-content: center !important;
          padding: 14px 20px !important;
        }
        .hero-link-ghost {
          margin-top: 4px;
        }
        .hero-visual-col {
          margin-top: 8px;
        }
        .hero-factory-card {
          border-radius: 16px !important;
        }
        .hero-stat-chip {
          left: 12px !important;
          right: 12px !important;
          bottom: 12px !important;
          padding: 12px 14px !important;
          gap: 10px !important;
        }
        .hero-stat-icon {
          width: 36px !important;
          height: 36px !important;
        }
        .hero-stat-title {
          font-size: 0.85rem !important;
        }
        .hero-stat-sub {
          font-size: 0.72rem !important;
        }
        .hero-stat-value {
          font-size: 1.25rem !important;
        }
        .hero-rfq-card {
          position: static !important;
          width: 100% !important;
          left: auto !important;
          bottom: auto !important;
          margin-top: 28px !important;
        }
      }

      /* ---------- Extra small phones ---------- */
      @media (max-width: 380px) {
        .hero-heading {
          font-size: 1.5rem !important;
        }
        .hero-eyebrow {
          font-size: 9.5px !important;
        }
      }
    `}</style>
  );
}

const styles = {
  stage: {
    position: "relative",
    width: "100%",
    minHeight: "50vh",
    display: "flex",
    alignItems: "center",
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "#ffffff",
    background:
      "radial-gradient(1200px 600px at 18% -10%, rgba(247,148,29,0.10), transparent 60%), radial-gradient(900px 700px at 85% 30%, rgba(50,80,180,0.25), transparent 60%), linear-gradient(135deg, #070c1f 0%, #0b1330 45%, #101b40 100%)",
    overflow: "hidden",
    padding: "30px 0",
    boxSizing: "border-box",
  },
  gridOverlay: {
    position: "absolute",
    inset: 0,
    backgroundImage:
      "linear-gradient(rgba(255,255,255,0.035) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.035) 1px, transparent 1px)",
    backgroundSize: "48px 48px",
    WebkitMaskImage:
      "radial-gradient(ellipse 100% 100% at 50% 0%, black 40%, transparent 90%)",
    maskImage:
      "radial-gradient(ellipse 100% 100% at 50% 0%, black 40%, transparent 90%)",
    pointerEvents: "none",
  },
  wrap: {
    position: "relative",
    zIndex: 2,
    width: "100%",
    maxWidth: 1280,
    margin: "0 auto",
    padding: "0 32px",
    display: "grid",
    gridTemplateColumns: "1.05fr 0.95fr",
    gap: 48,
    alignItems: "center",
    boxSizing: "border-box",
  },
  eyebrow: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    padding: "9px 18px",
    border: "1px solid rgba(255,255,255,0.14)",
    borderRadius: 999,
    background: "rgba(255,255,255,0.04)",
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontSize: 12.5,
    fontWeight: 600,
    letterSpacing: "0.14em",
    color: "#e7ebff",
    maxWidth: "100%",
  },
  heading: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "clamp(2.2rem, 4vw, 3.8rem)",
    lineHeight: 1.08,
    letterSpacing: "-0.02em",
    marginTop: 26,
  },
  accent: {
    color: "#f7941d",
  },
  lede: {
    marginTop: 28,
    maxWidth: 540,
    fontSize: "1.05rem",
    lineHeight: 1.7,
    color: "#b7c0dd",
  },
  ctaRow: {
    marginTop: 38,
    display: "flex",
    alignItems: "center",
    gap: 28,
    flexWrap: "wrap",
  },
  btn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 600,
    fontSize: "0.98rem",
    padding: "15px 26px",
    borderRadius: 10,
    textDecoration: "none",
    cursor: "pointer",
    border: "1px solid transparent",
    boxSizing: "border-box",
  },
  btnPrimary: {
    background: "linear-gradient(135deg, #f7941d, #ef7f0e)",
    color: "#1a1204",
    boxShadow: "0 10px 30px -8px rgba(247,148,29,0.35)",
  },
  btnSecondary: {
    background: "rgba(255,255,255,0.03)",
    borderColor: "rgba(255,255,255,0.16)",
    color: "#ffffff",
  },
  linkGhost: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 600,
    fontSize: "0.96rem",
    color: "#b7c0dd",
    textDecoration: "none",
    borderBottom: "1px solid transparent",
  },
  visualCol: {
    position: "relative",
    width: "100%",
  },
  factoryCard: {
    position: "relative",
    borderRadius: 22,
    overflow: "hidden",
    border: "1px solid rgba(255,255,255,0.08)",
    boxShadow: "0 40px 80px -24px rgba(0,0,0,0.6)",
    aspectRatio: "16 / 10.2",
  },
  factoryScene: {
    position: "absolute",
    inset: 0,
    background: "linear-gradient(180deg, #17223f 0%, #0f1830 55%, #0a1226 100%)",
  },
  statChip: {
    position: "absolute",
    left: 20,
    right: 20,
    bottom: 20,
    display: "flex",
    alignItems: "center",
    gap: 16,
    padding: "16px 20px",
    borderRadius: 14,
    background: "rgba(10,16,34,0.72)",
    backdropFilter: "blur(10px)",
    border: "1px solid rgba(255,255,255,0.1)",
    boxSizing: "border-box",
  },
  statIcon: {
    width: 42,
    height: 42,
    borderRadius: 10,
    background: "linear-gradient(135deg, #f7941d, #ef7f0e)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
  },
  statTitle: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "0.98rem",
    color: "#ffffff",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statSub: {
    fontSize: "0.82rem",
    color: "#8a93b8",
    marginTop: 2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  statValue: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "1.6rem",
    color: "#f7941d",
    flexShrink: 0,
  },
  rfqCard: {
    position: "absolute",
    left: -24,
    bottom: -46,
    width: 300,
    background: "#f4f6fb",
    color: "#0b1330",
    borderRadius: 16,
    padding: "20px 22px",
    boxShadow: "0 30px 60px -18px rgba(0,0,0,0.55)",
    boxSizing: "border-box",
  },
  rfqTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: "0.1em",
    color: "#8a7100",
    textTransform: "uppercase",
  },
  rfqTitle: {
    fontFamily: "'Sora', 'Segoe UI', sans-serif",
    fontWeight: 700,
    fontSize: "1.05rem",
    marginTop: 10,
    lineHeight: 1.35,
    color: "#0b1330",
  },
  rfqMeta: {
    marginTop: 8,
    fontSize: "0.85rem",
    color: "#5a6280",
  },
};